import type { AppBootstrapOptions } from 'owa-app-module/lib/types/AppBootstrapOptions';
import MailModule from 'owa-mail-module-view/lib/components/MailModule';
import getMailHeaderProps from 'owa-mail-module-view/lib/components/getMailHeaderProps';
import { mailModuleName } from './strings.locstring.json';
import loc from 'owa-localize';
import React from 'react';
import initializeMailModuleState from './initializeMailModuleState';
import { mailRouterOptions } from './routing/mailRoutes';
import { type OwaWorkload } from 'owa-workloads';
import { Module } from 'owa-workloads-module';
import controlIconRegistration from 'owa-control-icons/lib/data/controlIconsRegistration';
import surfaceActionIconsRegistration from 'owa-surface-action-icons/lib/data/surfaceActionIconsRegistration';
import { getAnalyticOptions } from 'owa-shared-analytics';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import { lazySetupMailModulePostRender } from 'owa-mail-post-boot';
import type { BootStrategies } from 'owa-shared-start-types';
import type { SearchBoxContainerHandle } from 'owa-search';
import { selectDefaultFolder } from 'owa-mail-folder-forest-actions';
import { mailAppRibbonProps } from 'owa-mail-ribbon';
import { getMailFavicon } from 'owa-mail-favicon';

// Initialize mail packages here:
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'owa-mail-list-selection-actions-v2';
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'owa-mail-folder-orchestration';
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'owa-public-folder-favorite';
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'owa-shared-folder';
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * We need to  register the lazy orchestrators early so Bizchat can set the correct context even if the module is not loaded yet
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'owa-bizchat-messaging-orchestration';

export function getMailBootstrapOptions(
    sessionPromise: Promise<SessionData | undefined>,
    strategies?: BootStrategies,
    requiredApplicationSettings?: string[]
): AppBootstrapOptions {
    return {
        initializeState: initializeMailModuleState,
        sessionPromise,
        routerOptions: mailRouterOptions,
        loaderOptions: {
            fadeOut: true,
            delayRender: true,
        },
        getModuleName: () => loc(mailModuleName),
        workload: 1,
        analyticsOptions: getAnalyticOptions(),
        iconFonts: [controlIconRegistration, surfaceActionIconsRegistration],
        postLazyAction: lazySetupMailModulePostRender,
        strategies,
        appModuleProps: {
            module: Module.Mail,
            renderModule: (searchBoxRef: React.RefObject<SearchBoxContainerHandle>) => (
                <MailModule searchBoxRef={searchBoxRef} />
            ),
            ribbonProps: mailAppRibbonProps,
            activeModuleAction: () => selectDefaultFolder('ModuleSwitcher'),
            getHeaderInfo: getMailHeaderProps,
            isSkiplinkEnabled: true,
            getOverrideFavIcon: getMailFavicon,
        },
        requiredApplicationSettings,
    };
}
